export default __webpack_public_path__ + "images/wegenwachtaea418954d7b6e59dcfdffd39d3f6848.svg";